
<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input v-model="queryParam.keywords" allowClear  placeholder="搜索关键字"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="赛季">
              <a-select v-model="queryParam.saiji" placeholder="请选择"
                        allowClear >
                <a-select-option v-for="(option,index) in saijiOptions" :value="option.id">{{option.name}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input v-model="queryParam.kaojiregist_code" placeholder="搜索授权编号"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input v-model="queryParam.danwei" placeholder="搜索单位名称"/>
              </a-form-item>
            </a-col>


            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间">
                <a-range-picker
                    v-model="time_range_moment"
                    style="width: 100%"
                    format="YYYY-MM-DD HH:mm:ss"
                    :showTime="{
                defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                }"
                />
              </a-form-item>
            </a-col>

          </template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator" >

      <a-button type="primary" icon="plus" @click="addHandle" >新建</a-button>
    </div>

    <s-table
        ref="table"
        size="default"
        :columns="columns"
        :data="loadData"
        :alert="{ show: true, clear: () => { this.selectedRowKeys = [] } }"
        :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >

      <span slot="name" slot-scope="text,record">
          <div style="margin-left: 10px; float: left">
            {{record.name}}
            <br/><span style="color: #999">{{record.province}}{{record.city}}{{record.county}}</span>
            <br/>
            举办时间 {{record.startdate}}
          </div>
      </span>
      <span slot="status" slot-scope="text,record">

        开始报名 {{record.stime|timeFormat}}
        <br/>
        结束报名 {{record.etime|timeFormat}}
        <br/>



        <a-tag v-if="record.status==1" color="green">进行中</a-tag>
        <a-tag v-else>未进行</a-tag>
        <a-tag v-if="record.type==1" color="green">显示</a-tag>
        <a-tag v-else>不显示</a-tag>


      </span>
      <span slot="action" slot-scope="text,record">
        <template >
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
<!--          <a @click="handleServiceType(record)">套餐设置</a>-->
<!--            <a-divider type="vertical" />-->
<!--          <a @click="handleBaoming(record)">报名管理</a>-->
<!--            <a-divider type="vertical" />-->
<!--          <a @click="handleDocument(record)">相关文件</a>-->
        </template>
      </span>
    </s-table>



    <a-modal
        :maskClosable="false"
        title="操作"
        :width="1200"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="visible"
        @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="名称"
                  hasFeedback
              >
                <a-input   v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入名称' }]}
            ]"
                           placeholder="请输入名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="年份"
                  hasFeedback
              >
                <a-select :disabled="formData.id>0" v-model="formData.saiji" placeholder="请选择"
                          allowClear >
                  <a-select-option v-for="(option,index) in saijiOptions" :value="option.id">{{option.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="主办时间"
                  hasFeedback
              >
                <a-input   v-decorator="[
              'datetime',
              {rules: [{ required: true, message: '请输入主办时间' }]}
            ]"
                           placeholder="请输入主办时间"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="主办地点"
                  hasFeedback
              >
                <a-input   v-decorator="[
              'city',
              {rules: [{ required: true, message: '请输入主办地点' }]}
            ]"
                           placeholder="请输入主办地点"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否进行"
                  hasFeedback
              >
                <r-switch  :formData="formData" field="status" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否显示"
                  hasFeedback
              >
                <r-switch  :formData="formData" field="type" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>
          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="报名时间"
                  hasFeedback
              >
                <a-range-picker
                    v-model="formData.time_range_moment"
                    :showTime="{
        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
      }"
                    format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>

            </a-col>
          </a-row>

        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleOk">保存</a-button>
      </template>
    </a-modal>




    <a-modal
        :maskClosable="false"
        title="服务套餐设置"
        :width="1000"
        style="top: 20px;"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="serviceTypeVisible"
        @ok="serviceTypeVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-table
            :columns="serviceTypeColumns"
            :dataSource="serviceTypeList"
            :pagination="false"
            rowKey="id"
            :scroll="{ y: 300 }"
            bordered
        >

        <span slot="show" slot-scope="text,record">
          <a-tag v-if="record.show==1" color="green">显示</a-tag>
          <a-tag v-else>隐藏</a-tag>
        </span>
          <span slot="loc" slot-scope="text,record">
          <a-tag v-if="record.loc==1" color="green">是</a-tag>
          <a-tag v-else>否</a-tag>
        </span>
          <span slot="onlyprovince" slot-scope="text,record">
          <a-tag v-if="record.onlyprovince==1" color="green">是</a-tag>
          <a-tag v-else>否</a-tag>
        </span>

          <template slot="action" slot-scope="text,record,index">
            <a href="javascript:;" @click="onEditServiceType(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm
                title="确定删除此套餐吗"
                @confirm="deleteServiceType(record,index)"
                okText="确定"
                cancelText="取消"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
          <template slot="footer" slot-scope="currentPageData">
            <a-button icon="plus" @click="onAddServiceType">新增</a-button>
          </template>
        </a-table>
      </a-spin>
    </a-modal>

    <a-modal
        :maskClosable="false"
        title="套餐操作"
        :width="1000"
        :bodyStyle="{maxHeight:'500px','overflowY':'scroll'}"
        v-model="serviceTypeFormVisible"
        @ok="handleServiceTypeOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form2" >
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="名称"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'name',
              {rules: [{ required: true, message: '请输入套餐名称' }]}
            ]"
                          placeholder="请输入名称"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="说明"
                  hasFeedback
              >
                <a-textarea    v-decorator="[
              'note',
              {rules: [ ]}
            ]"
                               placeholder="请输入说明"/>
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="单价"
                  hasFeedback
              >
                <a-input  v-decorator="[
              'price',
              {rules: [{ required: true, message: '请输入单价' }]}
            ]"
                          placeholder="请输入单价"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="仅限本省购买"
                  hasFeedback
              >
                <r-switch  :formData="serviceTypeFormData" field="onlyprovince" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>

          </a-row>


          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="仅限本地购买"
                  hasFeedback
              >
                <r-switch  :formData="serviceTypeFormData" field="loc" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  label="是否显示"
                  hasFeedback
              >
                <r-switch  :formData="serviceTypeFormData" field="show" :checkedValue="1" :unCheckedValue="2"  checkedChildren="是" unCheckedChildren="否" />
              </a-form-item>
            </a-col>


          </a-row>


          <a-row :gutter="48">

            <a-col :md="48" :sm="24">
              <a-form-item
                  :labelCol="{
          xs: { span: 12 },
          sm: { span: 4 }}"
                  :wrapperCol="{
          xs: { span: 24 },
          sm: { span: 12 }}"
                  label="仅限报过以下场次"
                  hasFeedback
              >
                <a-select style="width: 500px" v-model="serviceTypeFormData.onlybaos"
                          mode="multiple" placeholder="请选择"
                          allowClear >
                  <a-select-option v-for="(option,index) in saiquOptions" :value="option.id">{{option.name}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>


          </a-row>


        </a-form>

      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleServiceTypeCancel">取消</a-button>
        <a-button key="forward" :loading="saveLoading" type="primary" @click="handleServiceTypeOk">保存</a-button>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import STable from '@/components/table/'
import ATextarea from 'ant-design-vue/es/input/TextArea'
import AInput from 'ant-design-vue/es/input/Input'
import EditableCell from '@/components/EditableCell/'
import PicUploader from '@/components/PicUploader/'
import FileUploader from '@/components/FileUploader/'
import ContentPicker from '@/components/ContentPicker/'
import RSwitch from '@/components/RSwitch/'
import areaOptions from '@/utils/area'
import moment from 'moment'
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

import { getSaiquList ,getSaiquDetail,editSaiqu,addSaiqu,getSaijiList,getServiceTypeList,serviceTypeDelete,getServiceTypeDetail,editServiceType,addServiceType,addHuiyiFile, getHuiyiFileList,deleteHuiyiFile,getSetting,setSetting  } from '@/api/nlcs'

import { getExameOptions} from '@/api/wexame'
export default {
  name: 'HuiyiSaiquList',
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    ContentPicker,
    STable,
    RSwitch,
    EditableCell,
  },
  data () {
    return {
      areaOptions,
      visible: false,
      documentVisible: false,
      saveLoading:false,
      settingVisible:false,
      shenbaoOptions : [
        {'label':'裁判等级（舞蹈）','value':'caipandengjiwudao'},{'label':'裁判等级（技巧）','value':'caipandengjijiqiao'},{'label':'教练等级（舞蹈）','value':'jiaoliandengjiwudao'},{'label':'教练等级（技巧）','value':'jiaoliandengjijiqiao'}
      ],
      gjsbOptions : [
        {'label':'高级裁判员资质申请','value':'caipan'},{'label':'高级教练员资质申请','value':'jiaolian'}
      ],
      formData:{
        id:0,
        status:1,
        type:1,
        is_online:2,
        can_kaipiao:2,
        need_video:2,
        can_exame:2,
        onlyprovince:2,
        onlycity:2,
        danwei:'',
        gametype:'',
        saidate_moment:null,
        saidate:'',
        time_range_moment:[],
        time_range:[],
        erweiimg:[],
        wechat_erweiimg:[],
        areas:[],
        extra_field:[],
        shenbaotype:[],
        gjsbshow:[],
        pic:[],
        pics:[],
        group_ids:[],
        exame_ids:[],
        stationlimitmember: 1,
        can_pay: 2,
        is_danwei_cert: 2,
        memberoneprice: '',
        books_cost_price: '',
      },
      huiyiFormData:{
        //station_id=271&content_id=33
        station_id:undefined,
        content_id: undefined,
      },
      saijiOptions:[],
      groupOptions:[],
      exameOptions:[],
      saiquOptions:[],
      typeOptions:[{
        name:'会议',
        id:1,
      },{
        name:'培训',
        id:2,
      },{
        name:'训练营',
        id:3,
      },{
        name:'论文科报会',
        id:4,
      }],
      labelCol: {
//          xs: { span: 24 },
//          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords:'',
      },
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '名称',
          dataIndex: 'name',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 162,
          scopedSlots: { customRender: 'action' },
        }
      ],

      //人员管理表头
      documentColumns: [
        {
          title: '#',
          dataIndex: 'id',
          width: '50px'
        },
        {
          title: '标题',
          dataIndex: 'title',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '类型',
          width:'100px',
          dataIndex: 'type',
          scopedSlots: { customRender: 'typename' },
          filters: [
            {
              text: '文件',
              value: '1'
            },
            {
              text: '导师',
              value: '2'
            },
          ],
          filterMultiple:false,
          onFilter: (value, record) => record.type == value,
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '150px',
          scopedSlots: { customRender: 'action' },
        }
      ],
      documentList:[],
      documentKeywords: '',
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData');
        console.log(this.queryParam);
        let that= this;


        this.queryParam = Object.assign(this.queryParam,parameter);
        return getSaiquList(this.queryParam)
            .then(res => {
              console.log('res');
              return res.data
            })
      },

      selectedRowKeys: [],
      selectedRows: [],

      //表头
      serviceTypeColumns: [
        {
          title: '名称',
          dataIndex: 'name',
        },
        {
          title: '价格',
          width: '150px',
          dataIndex: 'price',
        },
        {
          title: '仅限本地',
          width: '150px',
          dataIndex: 'loc',
          scopedSlots: { customRender: 'loc' },
        },
        {
          title: '仅限本省',
          width: '150px',
          dataIndex: 'onlyprovince',
          scopedSlots: { customRender: 'onlyprovince' },
        },
        {
          title: '显示',
          dataIndex: 'show',
          width: '150px',
          scopedSlots: { customRender: 'show' },
        },
        {
          title: '操作',
          dataIndex: 'action',
          fixed: 'right',
          width: 150,
          scopedSlots: { customRender: 'action' },
        },
      ],
      serviceTypeQuery: {
        saiqu: 0,
      },
      serviceTypeVisible:false,
      serviceTypeFormVisible:false,
      serviceTypeList: [],
      serviceTypeFormData:{
        id:0,
        name:'',
        onlyprovince: 1,
        loc:1,
        show:1,
        onlybaos:[],
      },
      settingFormData:{
        gjsb_cp2_to_cp1:0,
        gjsb_cp1_to_guojia:0,
        gjsb_cpguojia_to_guoji:0,
        gjsb_jl2_to_jl1:0,
        gjsb_jlyi_to_gaoji:0,
        gjsb_jlgao_to_guojia:0,
      },
    }
  },
  computed:{
  },
  created(){
  },

  mounted(){
    let that = this;
    that.getSaijiOptions();
  },
  methods: {
    moment,
    addHandle(){
      this.formData = {
        id:0,
        status:1,
        is_online:2,
        can_kaipiao:2,
        need_video:2,
        can_exame:2,
        type:1,
        danwei:'',
        gametype:'',
        saidate_moment:null,
        saidate:'',
        time_range_moment:[],
        time_range:[],
        date_range_moment:[],
        date_range:[],
        erweiimg:[],
        wechat_erweiimg:[],
        areas:[],
        onlyprovince:2,
        shenbaotype:[],
        gjsbshow:[],
        pic:[],
        pics:[],
        extra_field:[],
        group_ids:[],
        exame_ids:[],
        stationlimitmember: 1,
        can_pay: 2,
        is_danwei_cert: 2,
        memberoneprice: '',
        books_cost_price: '',
      }
          this.form.resetFields();
      this.visible = true
    },
    handleCancel(){
      this.visible = false
    },
    handleServiceTypeCancel(){
      this.serviceTypeFormVisible = false
    },
    getSaijiOptions(){
      let that = this;
      getSaijiList().then(res =>{
        that.saijiOptions = res.data.list
      })
    },
    getGroupOptions(){
      let that = this;
      getGroupList().then(res =>{
        that.groupOptions = res.data.list
      })
    },
    getExameOptions(){
      let that = this;
      getExameOptions().then(res =>{
        that.exameOptions = res.data
      })
    },
    stationOptions(){
      let that = this;
      stationOptions().then(res =>{
        that.saiquOptions = res.data
      })
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced
    },
    handleEdit(record){
      let self = this
      this.visible = true
      getSaiquDetail({ id: record.id }).then(res => {
        setTimeout(() =>{
          self.form.setFieldsValue({ ...res.data })
          self.formData.id = record.id;
          console.log('handleEdit')
          if(res.data.area){
            res.data.areas = [res.data.area.substring(0,2)+'0000',res.data.area.substring(0,4)+'00',res.data.area];
          }else{
            res.data.areas = [];
          }
          res.data.time_range_moment = [moment(res.data.stime*1000),moment(res.data.etime*1000)];

          self.formData = { ...res.data };
        },200)
      })
      // console.log(this.mdl)
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false)
    },

    addExtraField(){
      if(this.formData.extra_field.length &&  this.formData.extra_field[this.formData.extra_field.length-1].name ==''){
        return false;
      }
      this.formData.extra_field.push({'label' :'','desc':'','required':true});
    },
    removeExtraField(k){
      this.formData.extra_field.splice(k,1);
    },
    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault()
      if(self.formData.time_range_moment.length!=2){
        self.$message.error('请选择时间范围');
        return ;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.formData)
          self.saveLoading = true;
          if(self.formData.id>0){

            editSaiqu({
              id:self.formData.id,
              name:values.name,
              datetime:values.datetime,
              city:values.city,
              saiji:self.formData.saiji,
              type:self.formData.type,
              status:self.formData.status,
              time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')],

            }).then(res => {
              self.$message.success('修改成功')
              self.$refs.table.refresh()
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }else{
            addSaiqu({
              name:values.name,
              datetime:values.datetime,
              city:values.city,
              saiji:self.formData.saiji,
              type:self.formData.type,
              status:self.formData.status,
              time_range:[self.formData.time_range_moment[0].format('YYYY-MM-DD HH:mm:ss'),self.formData.time_range_moment[1].format('YYYY-MM-DD HH:mm:ss')]
            }).then(res => {
              self.$message.success('新增成功')
              self.$refs.table.refresh(false)
              self.visible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }

        }
      })
    },
    onAddServiceType(){
      this.serviceTypeFormData = {
        id:0,
        name:'',
        onlyprovince: 1,
        loc:1,
        onlybaos:[],
        show:1,
      },
          this.form2.resetFields();
      this.serviceTypeFormVisible = true
    },
    onEditServiceType(record){
      let self = this
      this.serviceTypeFormVisible = true
      getServiceTypeDetail({ id: record.id }).then(res => {
        setTimeout(() =>{
          self.form2.setFieldsValue({ ...res.data })
          self.serviceTypeFormData.id = record.id;
          self.serviceTypeFormData = { ...res.data };
          self.serviceTypeFormData.onlybaos = self.serviceTypeFormData.onlybaos.map(item =>{
            return parseInt(item)
          });
        },200)
      })
    },
    deleteServiceType(record){
      let self = this;
      serviceTypeDelete({ id: record.id }).then(res =>{
        self.fetchServiceTypeList();
      })
    },
    handleServiceType(record){
      let self = this
      self.fetchServiceTypeList()
      self.serviceTypeQuery.saiqu = record.id;
      self.serviceTypeVisible = true
    },
    handleBaoming(record) {
      // console.log("handleBaoming", record)
      this.$router.push({
        name: 'HuiyiApplyList',
        query: {
          saiji: record.saiji,
          saiqu: record.id,
        }
      })
    },

    handleDocument(record) {
      let self = this
      self.huiyiFormData.station_id = record.id;
      self.getDocumentList();

      this.documentVisible = true
    },

    getDocumentList(){
      let self = this
      getHuiyiFileList({station_id: self.huiyiFormData.station_id}).then(res => {
        self.documentList = res.data
      })
    },

    addFile(){
      let self = this;
      if(!self.huiyiFormData.content_id){
        self.$message.error('请选择文章');
        return ;
      }
      if(!self.huiyiFormData.type){
        self.$message.error('请选择类型');
        return ;
      }
      addHuiyiFile(self.huiyiFormData).then(res => {
        self.getDocumentList();

        self.huiyiFormData.content_id = undefined;
        // self.huiyiFormData.station_id = undefined;

        self.$message.success('新增成功')
      }).catch(err =>{
        self.$message.error(err.data.msg);
      })
    },
    deleteFile(record,index){
      let self = this;
      deleteHuiyiFile({
        station_id:self.huiyiFormData.station_id,
        content_id:record.id,
      }).then(res => {
        self.$message.success('删除成功')
        self.documentList.splice(index,1);
      }).catch(err =>{
        self.$message.error(err.data.msg);
      })
    },


    fetchServiceTypeList() {
      let self = this
      getServiceTypeList(self.serviceTypeQuery).then(res => {
        self.serviceTypeList = res.data
      })
    },


    // 增改 处理
    handleServiceTypeOk(e) {
      let self = this;
      e.preventDefault()
      this.form2.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          console.log('Received valuess of formData: ', self.serviceTypeFormData)
          self.saveLoading = true;
          if(self.serviceTypeFormData.id>0){
            editServiceType({
              id:self.serviceTypeFormData.id,
              name:values.name,
              price:values.price,
              note:values.note,
              loc:self.serviceTypeFormData.loc,
              onlyprovince:self.serviceTypeFormData.onlyprovince,
              show:self.serviceTypeFormData.show,
              onlybaos:self.serviceTypeFormData.onlybaos,
            }).then(res => {
              self.$message.success('修改成功')

              self.fetchServiceTypeList();

              self.serviceTypeFormVisible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }else{
            addServiceType({
              name:values.name,
              price:values.price,
              note:values.note,
              saiqu:self.serviceTypeQuery.saiqu,
              loc:self.serviceTypeFormData.loc,
              onlyprovince:self.serviceTypeFormData.onlyprovince,
              show:self.serviceTypeFormData.show,
              onlybaos:self.serviceTypeFormData.onlybaos,
            }).then(res => {
              self.$message.success('新增成功')
              self.fetchServiceTypeList();


              self.serviceTypeFormVisible = false;
              self.saveLoading = false;
            }).catch(err =>{
              self.$message.error(err.data.msg);
              self.saveLoading = false;
            })
          }

        }
      })
    },



    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },


    onSetting(){
      let self = this
      this.settingVisible = true
      getSetting( ).then(res => {
        self.settingFormData = res.data;
        // console.log(this.mdl)
      })
    },


    // 增改 处理
    handleSettingOk(e) {
      let self = this;
      e.preventDefault()
      this.form2.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          self.saveLoading = true;
          setSetting(self.settingFormData).then(res => {
            self.$message.success('修改成功')
            self.settingVisible = false;
            self.saveLoading = false;
          }).catch(err =>{
            self.$message.error(err.data.msg);
            self.saveLoading = false;
          })
        }
      })
    },


  },
  filters:{
  },
  watch: {
  }
}
</script>
